import { LocalStorageKeys } from '../constants/enums';

export function getBootLocalStorageKeyBySuffix(suffix: string) {
  return `ac_boot_${suffix}` as LocalStorageKeys;
}
